import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

/**
 * Brand eyebrow: a short blue rule followed by a mono uppercase label.
 * Matches DESIGN.md §3 eyebrow pattern.
 */
export function Eyebrow({ children, className }: EyebrowProps) {
  return (
    <p
      className={cn(
        "flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-brand-muted",
        className
      )}
    >
      <span className="block h-px w-8 bg-brand-accent" />
      {children}
    </p>
  );
}
